import { useEffect, useState } from "react";
import { fetchFPLData } from "../api/fplApi";

const TopSelectedPlayers = () => {
  const [players, setPlayers] = useState([]);
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    fetchFPLData().then((data) => {
      if (!data) return;
      setTeams(data.teams || []);
      setPlayers([...data.elements].sort((a, b) => parseFloat(b.selected_by_percent) - parseFloat(a.selected_by_percent)).slice(0, 5));
    }).catch(() => {});
  }, []);

  if (!players.length) return <div className="fpl-empty">Loading ownership data…</div>;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-3">
      {players.map((p, i) => {
        const team = teams.find((t) => t.id === p.team);
        return (
          <div className="fpl-owner-card" key={p.id}>
            <div className="fpl-rank-badge">#{i + 1}</div>
            <img
              src={`https://resources.premierleague.com/premierleague25/photos/players/110x140/${p.code}.png`}
              alt={p.web_name}
              onError={(e) => { e.currentTarget.src = `https://fantasy.premierleague.com/dist/img/shirts/standard/shirt_${p.team_code}-220.webp`; }}
            />
            <div className="min-w-0">
              <div className="font-extrabold text-slate-900 truncate">{p.web_name}</div>
              <div className="text-xs text-slate-400">{team?.short_name || "FPL"}</div>
            </div>
            <div className="ml-auto text-right">
              <div className="text-lg font-black text-violet-700">{p.selected_by_percent}%</div>
              <div className="text-[10px] uppercase tracking-wider text-slate-400">selected</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TopSelectedPlayers;
